import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import swal from 'sweetalert';
import { FaInstagram, FaTwitter, FaFacebookF } from 'react-icons/fa';
import Clefill from "../../../assets/svg/footer-clefill-logo";

const Footer = () => {

    const isValidLocation = useSelector(state => state.auth.isValidLocation)
    const history = useHistory()

    const handleRedirect = (path) => {
        if (!isValidLocation) {
            swal('Location unavailable !', 'Please select location !', 'error')
        } else {
            history.push(path)
        }
    }

    return (
        <>
            
            <div className="footer-wrapper">
                <div className="footer-content">
                    <h2 className="footer-logo">
                        <i> <Clefill /> </i>
                        
                        {/* <span className="logo-highlight">r</span>esponsible <span className="logo-gradient">ones</span> */}
                        {/* <img src={Clefill} alt="responsible ones logo" className="footer-logo-img" /> */}
                    </h2>

                    <div className="social-icons">
                    <a
                            href="https://instagram.com/clefillproducts?igshid=YmMyMTA2M2Y="
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-icon"
                        >
                            <FaInstagram />
                        </a>
                        <a
                            href="https://twitter.com/clefillproducts?s=11&t=kZCCypuuVfaW2pIJHXkQYA"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-icon"
                        >
                            <FaTwitter />
                        </a>
                        
                        
                        <a
                            href="https://www.facebook.com/profile.php?id=100087878525201&mibextid=LQQJ4d"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-icon"
                        >
                            <FaFacebookF />
                        </a>
                        {/* <FaFacebookF /> */}
                    </div>

                    <div className="footer-links">
                        <ul>
                            <li onClick={() => handleRedirect('/product_list/refill/all')}>Refills</li>
                            <li onClick={() => handleRedirect('/product_list/prefill/dish-wash-gel')}>Dishawash Gel</li>
                            <li onClick={() => handleRedirect('/product_list/prefill/laundry-care')}>Liquid Detergent</li>
                            <li onClick={() => handleRedirect('/product_list/prefill/floor-cleaner')}>Floor Cleaners</li>
                        </ul>
                        <ul>
                            <li onClick={() => handleRedirect('/product_list/prefill/glass-cleaner-')}>Glass Cleaner</li>
                            <li onClick={() => handleRedirect('/product_list/prefill/toilet-cleaner')}>Toilet Cleaner</li>
                            <li onClick={() => handleRedirect('/product_list/prefill/bathroom-cleaner')}>Bathroom Cleaner</li>
                            <li onClick={() => handleRedirect('/product_list/prefill/hand-wash')}>Hand Care</li>
                        </ul>
                        <ul>
                            <li onClick={() => handleRedirect('/product_list/prefill/all')}>Shop All</li>
                            <li onClick={() => handleRedirect('/subscribe_and_save')}>Subscribe & Save</li>
                            <li onClick={() => handleRedirect('/contactus')}>Contact Us</li>
                        </ul>
                        <ul>
                            <li onClick={() => handleRedirect('/about_clefill')}>Our Story</li>
                            
                            {/* <li>FAQs</li> */}
                            <li onClick={() => handleRedirect('/cms/pp')}>Privacy Policy</li>
                            <li onClick={() => handleRedirect('/cms/tc')}>Terms & Conditions</li>
                            <li onClick={() => handleRedirect('/cms/rrd')}>Return and Refund Policy</li>
                        </ul>
                    </div>
                </div>


            </div>
            <div className="footer-bottom">
                Copyright 2025, Clefill
            </div>
        </>
    );
}

export default Footer;